<template>

  <section class="box-investment-steps">
    <h1 class="maintitle"><b class="-green">4 pasos</b> para financiarte en Cumplo</h1>
    <div class="container">
      <div class="row row-responsive">
        <div class="column column-sm-10 -hidden-xs"></div>
        <div class="column column-sm-40">
          <div class="box-step step1">
            <div class="row row-responsive">
              <div class="column column-sm-33">
                <div class="number">1</div>
              </div>
              <div class="column column-sm-66 -hidden-xs">
                <img src="/static/svg/funding-step1.svg">
              </div>
            </div>
            <div class="row">
              <div class="column">
                <p class="title">Regístrate.</p>
                <p>Haz click en el botón de ¡Aplica aquí!, déjanos tus datos para que un representante comercial se ponga en contacto contigo y atienda tu solicitud.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column column-sm-40">
          <div class="box-step step2">
            <div class="row row-responsive">
              <div class="column column-sm-33">
                <div class="number">2</div>
              </div>
              <div class="column column-sm-66 -hidden-xs">
                <img src="/static/svg/funding-step2.svg">
              </div>
            </div>
            <div class="row">
              <div class="column">
                <p class="title">Envía tus documentos.</p>
                <p>Un representante te contactará y te pedirá los documentos necesarios para para evaluar tu solicitud.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column column-sm-10 -hidden-xs"></div>
      </div>
      <div class="row row-responsive">
        <div class="column column-sm-10 -hidden-xs"></div>
        <div class="column column-sm-40">
          <div class="box-step step3">
            <div class="row row-responsive">
              <div class="column column-sm-33">
                <div class="number">3</div>
              </div>
              <div class="column column-sm-66 -hidden-xs">
                <img src="/static/svg/funding-step3.svg">
              </div>
            </div>
            <div class="row">
              <div class="column">
                <p class="title">Publicamos tu crédito.</p>
                <p>Una vez evaluada y aprobada tu solicitud, se publica en la plataforma para que los inversionistas financien el crédito.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column column-sm-40">
          <div class="box-step step4">
            <div class="row row-responsive">
              <div class="column column-sm-33">
                <div class="number">4</div>
              </div>
              <div class="column column-sm-66 -hidden-xs">
                <img src="/static/svg/funding-step4.svg">
              </div>
            </div>
            <div class="row">
              <div class="column">
                <p class="title">Recibe tu dinero.</p>
                <p>Al financiarse la totalidad del crédito, este monto se deposita en tu cuenta bancaria.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column column-sm-10 -hidden-xs"></div>
      </div>
    </div>
  </section>

</template>

<script>

export default {
  name: 'FundingSteps2',
  data () {
    return {
    }
  }
}

</script>

<style lang="scss" scoped>

.box-investment-steps {
  padding: 4rem 0;

  .maintitle {
    margin-bottom: 5rem;
    font-size: 2.6em;
  }

  .box-step {
    margin: 1rem auto 2rem;
    padding: 0;
    border: 0;
    background-color: transparent;
    border-radius: 0;

    .number {
      $s: 8rem;

      margin: 1.1rem auto 0;
      width: $s;
      height: $s;
      line-height: $s;
      font-weight: normal;
      font-size: 3em;
      color: $white;
      text-align: center;
      border-radius: 50%;
    }

    .title {
      margin: 2rem 0 1.5rem;
      font-size: 1.5em;
      line-height: 1.2;
    }

    &.step1 {
      $color: #568889;

      .number {
        background-color: $color;
      }
      .title {
        color: $color;
      }
    }

    &.step2 {
      $color: #B14D48;

      .number {
        background-color: $color;
      }
      .title {
        color: $color;
      }
    }

    &.step3 {
      $color: #3F56B6;

      .number {
        background-color: $color;
      }
      .title {
        color: $color;
      }
    }

    &.step4 {
      $color: #AC9855;

      .number {
        background-color: $color;
      }
      .title {
        color: $color;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/funding/FundingSteps.vue